(function () {
    angular
    .module('info', []);
})();
